import React, { Fragment } from 'react';
import T from 'prop-types';
import { isEmpty } from 'lodash-es';

import skeletons from './Skeletons';
import SimpleCard from '../../../Card/SimpleCard';
import ErrorStateWithReload from '../../../ErrorStateWithReload';
import BaseChart from '../../../../pages/company-page-v2/components/CompanyPerformance/Drivers/BaseView/BaseChart';

const chartOptions = [
  { metric: 'downloads' },
  { metric: 'mau' },
];

const chartStyleOverride = {
  axisLabelsFontSize: 11,
  chartHeight: 210,
};

const DriversQV = ({
  data,
  settings,
}) => {
  if (settings.error) {
    return <ErrorStateWithReload />;
  }

  return (
    <SimpleCard
      className="drivers-qv"
      headerLeft={<h4 className="h4">Drivers</h4>}
      headerRight="Worldwide"
    >
      <div className="drivers-base-view">
        {chartOptions.map(item => (
          <Fragment key={item.metric}>
            {settings.pending && skeletons.drivers.baseChart}
            {!settings.pending && !isEmpty(data) && (
              <BaseChart
                data={data}
                metric={item.metric}
                overPeriod="year_over_year"
                showActivePoint
                showFooter={false}
                chartStyleOverride={chartStyleOverride}
              />
            )}
          </Fragment>
        ))}
      </div>
    </SimpleCard>
  );
};

DriversQV.propTypes = {
  data: T.object,
  settings: T.object.isRequired,
};

export default DriversQV;
